import { BACKEND_URL } from "./baseUrl";

export const SIGNATURE_STAGE_SIZE = Object.freeze({
  width: 180,
  height: 70,
});

export const SIGNATURE_IMAGE_MAX_SIZE = Object.freeze({
  maxWidth: 148,
  maxHeight: 54,
});

export function buildBackendAssetUrl(value) {
  const src = String(value ?? "").trim();
  if (!src) return "";
  if (/^(data:|blob:|https?:)/i.test(src)) return src;

  const apiBase = BACKEND_URL.replace(/\/$/, "");
  const origin = apiBase.replace(/\/api$/, "");

  if (!src.startsWith("/")) {
    return `${origin}/${src}`;
  }

  return `${origin}${src}`;
}

export function getUserSignatureProfile(user = null) {
  const imageUrl = buildBackendAssetUrl(
    user?.signature_image_url ||
      user?.signatureImageUrl ||
      user?.signatureProfile?.imageUrl,
  );

  if (!imageUrl) return null;

  return {
    imageUrl,
  };
}
